import axios from "axios"
import { isLocalhost } from "../utils/settings"

export default axios.create({
  baseURL: isLocalhost ? "http://localhost:8090" : "https://api.yoursever.de",
  timeout: 15000,
  headers: { "X-API-Token": "FoN2gug420M8yGmOVdpDEQUfUcMuiQAv" },
  withCredentials: true,
})
